<div class="breadcrumbLayout">
  <kendo-breadcrumb [items]="breadCrumbs" [separatorSVGIcon]="breadCrumbSeparator" (itemClick)="onBreadCrumbClicked($event)"></kendo-breadcrumb>
</div>
<div class="toolbarLayout">
  <app-tool-bar [items]="toolbarItems"></app-tool-bar>
</div>
<br />

<kendo-stacklayout>
  <div class="detailContainer" #detailContainer>
    <form [formGroup]="detailForm" > <!--(ngSubmit)="onSubmit()"-->
      <div class="form-container">
        @for(view of views; track view.title){
        <div style="width: 40%; padding-right: 30px;">
          @for (cg of view.controls; track cg.id) {
          <kendo-card class="customerCard">
            <kendo-card-header class="cardHeader"> {{view.title}}  </kendo-card-header>
            @switch (cg.className) {
            @case ('TabControl') {
            <div>
              <app-tab [tab]="toTab(cg)" [data]="toTab(cg).tabOptions.data"></app-tab>
            </div>
            }
            @case('UiGroupControl')
              {
                @for(row of toGroup(cg).rows; track row) {
                  <div>
                    <app-kendo-card-form-row [controls]="row.controls" [form]="detailForm" [submitted]="submitted"></app-kendo-card-form-row>
                  </div>
                }
              }
              @default
              {
                <div>
                  <app-kendo-card-form-control [control]="cg" [form]="detailForm" [submitted]="submitted"></app-kendo-card-form-control>
                </div>
              }
            }
          </kendo-card>
          }
          <br />
        </div>
        }
      </div>
    </form>
  </div>
  @if (openDialog) {
  <kendo-dialog title="Remove {{ name }}" [animation]="true" (close)="closeRemoveDialog()">
    <p>Confirm Delete</p> <!--"general.confirmDelete" | translate-->

    <kendo-dialog-actions>
      <button kendoButton (click)="closeRemoveDialog()" [svgIcon]="dialogNo">
        No <!--"general.no" | translate-->
      </button>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="remove()" [svgIcon]="dialogYes">
        @if (dialogLoader) {
        <kendo-loader size="medium" themeColor="light"></kendo-loader>
        }
        Yes <!--"general.yes" | translate-->
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="remove()">
        @if (dialogLoader) {
        <kendo-loader size="medium" themeColor="light"></kendo-loader>
        }
        Yes <!--"general.yes" | translate-->
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
